import { put, takeEvery } from 'redux-saga/effects';

import { logger } from '@/config/logger';
import { groupMembers } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

import { fetchGroupMembers, fetchGroupMembersFailure, fetchGroupMembersSuccess } from '../actions';
import { normalizeGroupMembers } from '../normalizers';

function* handler({ meta: { groupId } }: ReturnType<typeof fetchGroupMembers>) {
    try {
        const { data } = yield groupMembers({ groupId });

        const { entities, result } = normalizeGroupMembers(data);

        yield put(fetchGroupMembersSuccess(groupId, entities.groupMembers, result));
    } catch (e) {
        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'error.groups.fetchMembers' },
            }),
        );
        logger.error(e);

        yield put(fetchGroupMembersFailure(groupId, e as Error));
    }
}

export function* fetchGroupMembersSaga() {
    yield takeEvery(fetchGroupMembers.toString(), handler);
}
